import React from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";

import AuthFooter from "components/Footers/AuthFooter.js";
import AuthNavbar from "components/Navbars/AuthNavbar.js";

const LegalPage = ({
  title,
  subtitle,
  lastUpdated,
  intro,
  sections,
  contactChannels = [],
  relatedLinks = [
    { to: "/privacy-policy", label: "Gizlilik Politikası" },
    { to: "/user-privacy", label: "Kullanıcı Gizliliği" },
  ],
  afterIntro = null,
}) => {
  return (
    <>
      <div className="main-content bg-secondary">
        <AuthNavbar />
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <Row className="justify-content-center">
              <Col lg="8" className="text-center">
                <Badge color="white" pill className="text-info mb-3">
                  Destinasyon 360
                </Badge>
                <h1 className="display-3 text-white mb-3">{title}</h1>
                <p className="text-lead text-light mb-0">{subtitle}</p>
              </Col>
            </Row>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-secondary" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </div>

        <Container className="mt--6 pb-5">
          <Row className="justify-content-center">
            <Col lg="10">
              <Card className="shadow border-0">
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="d-flex flex-column flex-md-row justify-content-between mb-4">
                    <div>
                      <small className="text-uppercase text-muted">
                        Son güncelleme
                      </small>
                      <p className="font-weight-bold mb-0">{lastUpdated}</p>
                    </div>
                    <div className="mt-3 mt-md-0">
                      {relatedLinks.map((link) => (
                        <Link
                          key={link.to}
                          to={link.to}
                          className="btn btn-sm btn-outline-info mr-2 mb-2"
                        >
                          {link.label}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <p className="lead text-muted">{intro}</p>

                  {afterIntro}

                  {contactChannels.length > 0 && (
                    <Row className="mt-4">
                      {contactChannels.map((channel) => (
                        <Col lg="4" md="6" className="mb-4" key={channel.label}>
                          <Card className="card-stats h-100 mb-0 shadow-sm border">
                            <CardBody>
                              <div className="d-flex align-items-center mb-3">
                                <div className="icon icon-shape bg-gradient-info text-white rounded-circle shadow">
                                  <i className={channel.icon} />
                                </div>
                                <div className="ml-3">
                                  <h3 className="h5 mb-0">{channel.label}</h3>
                                </div>
                              </div>
                              {channel.href ? (
                                <a
                                  href={channel.href}
                                  className="font-weight-bold text-default d-block mb-2"
                                  rel="noopener noreferrer"
                                  target={channel.href.startsWith("mailto:") ? undefined : "_blank"}
                                >
                                  {channel.value}
                                </a>
                              ) : (
                                <p className="font-weight-bold text-default mb-2">{channel.value}</p>
                              )}
                              {channel.hint && (
                                <p className="text-muted small mb-0">{channel.hint}</p>
                              )}
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}

                  {sections.map((section) => (
                    <section className="mt-5" key={section.title}>
                      <h2 className="h3 mb-3">{section.title}</h2>
                      {section.paragraphs?.map((paragraph) => (
                        <p className="text-muted" key={paragraph}>
                          {paragraph}
                        </p>
                      ))}
                      {section.items && (
                        <ul className="text-muted pl-4 mb-0">
                          {section.items.map((item) => (
                            <li className="mb-2" key={item}>
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                    </section>
                  ))}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
};

export default LegalPage;
